import { Action, CustomTagType, ErrorCodes, OperationType, Position, WarningType, WindowType } from "puzzle";
import AssignFilesSupplierDialog from "../../components/SupplierView/TaskList/Actions/Assign/AssignFilesSupplierDialog";

export const assignCrossoverDialog: Action = [{
  persistent: ['dialogData'],
  type: OperationType.addPersistentData
}, {
  className: 'sm confirm-light',
  title: 'assignCrossoverDialog.title',
  text: 'assignCrossoverDialog.text',
  items: [{
    operations: [{
      persistent: ['dialogData'],
      type: OperationType.removePersistentData
    }, {
      data: {
        template: {
          bind: {
            submissionData: '{dataItem}'
          }
        }
      },
      name: 'redirectToFilesTab',
      type: OperationType.action
    }],
    btnName: 'assignCrossoverDialog.selectFiles',
    btnConfig: {
      themeColor: 'primary',
      pos: Position.start
    }
  }, {
    operations: [{
      persistent: ['dialogData'],
      type: OperationType.removePersistentData
    }],
    btnName: 'assignCrossoverDialog.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      moduleName: 'App',
      name: 'getInitializeUserData',
      type: OperationType.addOperationData
    }, {
      data: {
        update: {
          dialogData: {
            bind: {
              supplierId: '_.get({getInitializeUserData},"userProfile.userInfo.supplierId")'
            }
          }
        }
      },
      name: 'assignSupplierDialog',
      type: OperationType.action
    }],
    btnName: 'assignCrossoverDialog.selectAll',
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    }
  }, {
    btnName: 'ESCAPE',
    operations: [{
      persistent: ['dialogData'],
      type: OperationType.removePersistentData
    }]
  }],
  type: OperationType.warning
}];

export const assignHasCompletedFilesWarning: Action = [{
  className: 'sm confirm-light',
  title: 'assignHasCompletedFilesWarning.title',
  text: 'assignHasCompletedFilesWarning.text',
  items: [{
    operations: {
      persistent: ['dialogData'],
      type: OperationType.removePersistentData
    },
    btnName: 'assignHasCompletedFilesWarning.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      actionType: {
        dispatcherId: 'mainDispatcher'
      },
      name: 'assignFileRequest',
      type: OperationType.action
    }],
    btnName: 'assignHasCompletedFilesWarning.continue',
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    }
  }, {
    btnName: 'ESCAPE',
    operations: [{
      persistent: ['dialogData'],
      type: OperationType.removePersistentData
    }]
  }],
  warningType: WarningType.warning,
  type: OperationType.warning
}, {
  dispatcherIds: ['batchPingDispatcher'],
  type: OperationType.unlink
}];

export const assignSupplierDialog: Action = [{
  data: {
    template: {
      method: 'post',
      url: '/jobPhaseFileView/summaryInfo',
      bind: {
        params: '{dialogData.summaryInfoParams} || {dialogData.assignRequestParams} '
      }
    }
  },
  mappingName: 'summaryInfo',
  type: OperationType.request
}, {
  data: {
    template: {
      assignFooterLabel: 'assignFilesSupplier.selectedFilesInfo',
      bind: {
        filesCount: '_.get({dialogData},"assignRequestParams.targetIds") ?  {dialogData.filesCount} : {dialogData.filesCount} - {summaryInfo.cancelledTargetsCount}',
      }
    }
  },
  type: OperationType.data
}, {
  title: 'assignFilesSupplierDialog.title',
  children: [{
    render: AssignFilesSupplierDialog,
    propArgs: ['dialogData', 'summaryInfo']
  }],
  className: 'sm assign-files',
  items: [{
    btnName: 'assignFilesSupplierDialog.selectedFiles',
    btnConfig: {
      customTagType: CustomTagType.counter,
      args: ['assignFooterLabel', 'filesCount'],
      pos: Position.start
    }
  }, {
    operations: [{
      persistent: ['dialogData'],
      type: OperationType.removePersistentData
    }],
    btnName: 'assignFilesSupplierDialog.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      moduleName: 'AssignFilesSupplierDialog',
      name: 'getDataForAssign',
      mappingName: 'assignRequestData',
      type: OperationType.addOperationData
    }, {
      data: {
        template: {
          bind: {
            dialogData: '{assignRequestData.dialogData}'
          }
        }
      },
      persistent: ['dialogData'],
      type: OperationType.addPersistentData
    }, {
      condition: `_.get({dialogData}, 'hasCompletedFiles')`,
      conditionOperations: [{
        windowType: WindowType.dialog,
        type: OperationType.closeWindow
      }, {
        name: 'assignHasCompletedFilesWarning',
        type: OperationType.action
      }],
      elseOperations: [{
        condition: `_.get({dialogData}, 'params.assigneeId')`,
        conditionOperations: [{
          name: 'assignFileRequest',
          type: OperationType.action
        }],
        type: OperationType.conditional
      }],
      type: OperationType.conditional
    }],
    close: false,
    btnName: 'assignFilesSupplierDialog.assign',
    btnConfig: {
      disabled: true,
      pos: Position.end,
      themeColor: 'primary'
    }
  }, {
    btnName: 'ESCAPE',
    operations: [{
      persistent: ['dialogData'],
      type: OperationType.removePersistentData
    }]
  }],
  type: OperationType.dialog
}];

export const updateFileAssignFooterButtons: Action = [{
  buttons: [{
    name: 'assignFilesSupplierDialog.assign',
    disabled: '{disabled}'
  }],
  type: OperationType.updateDialog
}];

export const assignFileRequest = [{
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}, {
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  data: {
    method: 'post',
    template: {
      bind: {
        url: `{dialogData.url}`,
        params: '{dialogData.params}'
      }
    }
  },
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}, {
  data: {
    template: {
      bind: {
        url: `{dialogData.url}`,
      },
      afterPingFinishAction: 'filesAssignedToaster',
      method: 'post'
    }
  },
  name: 'pingingRequest',
  type: OperationType.action
}];

export const getUsersForFileAssign: Action = [{
  data: {
    template: {
      method: 'get',
      bind: {
        url: '{url}'
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}, {
  moduleName: 'AssignFilesSupplierDialog',
  name: 'setGridData',
  args: ['responseData']
}];

export const filesAssignedToaster: Action = [{
  persistent: ['dialogData'],
  type: OperationType.removePersistentData
}, {
  data: {
    template: {
      flow: 'assign'
    }
  },
  moduleName: 'ToastNotifications',
  name: 'createCompleteNotifications',
  args: ['responseData', 'flow']
}, {
  name: 'refreshApp',
  type: OperationType.action
}, {
  moduleName: 'ToastNotifications',
  name: 'runStackedNotifications'
}];

export const redirectToFilesTab: Action = [{
  moduleName: 'TaskList',
  name: 'isDrawerOpen',
  type: OperationType.addOperationData
}, {
  condition: '{isDrawerOpen}',
  conditionOperations: [{
    data: {
      tabName: 'FILES'
    },
    args: ['tabName'],
    moduleName: 'TaskList',
    name: 'getDrawerTabIndexByName',
    mappingName: 'tabIndex',
    type: OperationType.addOperationData
  }, {
    persistent: ['tabIndex'],
    type: OperationType.addPersistentData
  }, {
    name: 'changeDrawerTab',
    type: OperationType.action
  }],
  elseOperations: [{
    name: 'switchToFilesTab',
    type: OperationType.action
  }],
  type: OperationType.conditional
}, {
  name: 'updateDrawerState',
  type: OperationType.action
}];
